import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Grid } from '@mui/material'
import { useCallback, useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion'
import { ContextOperacionNuevo, ContextOperacionNuevoType } from '../../NuevoSistema'
import { HttpCF } from './api/httpCF'
import { SeccionNuevoCFDatosOperacion } from './components/SeccionNuevoCFDatosOperacion'
import { OperacionCFInsert, schemaOperacionCFInsert } from './types/dto'
import { OperacionCFFields } from './types/fields'
import SeccionNuevoArchivo from '../../components/SeccionNuevoArchivo'
import SeccionNuevoCFDetalleTransaccion from './components/SeccionNuevoCFDetalleTransaccion'

interface NuevoSistemaCFProps {
  codSistemaPrincipal: number
}

const NuevoSistemaCF = ({ codSistemaPrincipal }: NuevoSistemaCFProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<OperacionCFInsert>({
    resolver: zodResolver(schemaOperacionCFInsert),
    defaultValues: {
      [OperacionCFFields.FechaSolicitud]: new Date(),
      [OperacionCFFields.CodPais]: codSistemaPrincipal,
    }
  })

  const handleCrearOperacion = useCallback(
    (data: OperacionCFInsert) => {
      submitOperacion(data, {
        apiCall: HttpCF.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    setSendPromise(() => 
      formMethods.handleSubmit(
        handleCrearOperacion, 
        (errors) => console.log("Falló la validación CF:", errors)
      )
    )
  }, [formMethods, handleCrearOperacion, setSendPromise])

  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoCFDatosOperacion 
            formMethods={formMethods} 
            codSistema={codSistema} 
            codPais={codSistemaPrincipal} 
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoCFDetalleTransaccion formMethods={formMethods} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoArchivo formMethods={formMethods}/>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaCF